import React, { useState } from "react";
import { AppConfig } from "../../../app-state";
import { Icon } from "../../../core/Icon";
export const EventGallery = (props) => {
    const imageData = props.imageData;
    const list = imageData.list;
    const [detailKey, setDetailKey] = useState(null);
    return (React.createElement(React.Fragment, null,
        detailKey !== null &&
            React.createElement("div", { className: "gallery-detail" },
                React.createElement("button", { className: "overlay", onClick: () => { setDetailKey(null); } },
                    React.createElement("span", { className: "sr-only" }, "Zav\u0159\u00EDt n\u00E1hled")),
                React.createElement("img", { onClick: () => { setDetailKey(null); }, src: AppConfig.filesPrefix + list[detailKey].path, className: "img", key: list[detailKey].path, alt: "Detail obrazové přílohy" }),
                React.createElement("button", { disabled: detailKey == 0, onClick: () => setDetailKey(detailKey - 1), className: "slidectrl prev" },
                    React.createElement(Icon, { c: ['chevron-left', 12, 12] }),
                    React.createElement("span", { className: "sr-only" }, "P\u0159edchoz\u00ED fotografie")),
                React.createElement("button", { disabled: detailKey == (list.length - 1), onClick: () => setDetailKey(detailKey + 1), className: "slidectrl next" },
                    React.createElement(Icon, { c: ['chevron-right', 12, 12] }),
                    React.createElement("span", { className: "sr-only" }, "N\u00E1sleduj\u00EDc\u00ED fotografie"))),
        React.createElement("div", { className: "gallery" }, list && list.length > 0 && list.map((event, index) => {
            return React.createElement("button", { onClick: () => setDetailKey(index), className: "item", key: index },
                React.createElement("img", { src: AppConfig.filesPrefix + event.path_thumb, className: "img", alt: "obrazová příloha č." + (index + 1), key: index }));
        }))));
};
